import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    FlexInput,
    PostcodeWrapper,
} from 'src/domains/players/webview/components/SignUp/signupPrimary/signUpViews/createAccount/yourDetails/YourDetails.style';
import { YourDetailsState } from 'src/domains/players/webview/components/SignUp/signupPrimary/signUpViews/createAccount/yourDetails/YourDetails.state';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';

interface PostCodeOnlyInputPropsType {
    yourDetailsState: YourDetailsState;
}

export const PostCodeOnlyInput = observer('PostCodeOnlyInput', (props: PostCodeOnlyInputPropsType) => {
    const common = useCommon();
    const appPlayersState = AppPlayersState.get(common);
    const { customKeyboard } = appPlayersState;
    const { yourDetailsState } = props;

    const configComponents = ConfigComponents.get(common);
    const languagesState = LanguagesState.get(common);
    const { config } = configComponents;

    return (
        <PostcodeWrapper>
            <FlexInput
                state={yourDetailsState.postcodeState}
                placeholder={
                    config.zipCodeAndCountryCheck === true
                        ? languagesState.getTranslation(
                              'signup.address-procedure.enter-postcode.placeholder-zip',
                              'Enter Zip Code'
                          )
                        : languagesState.getTranslation(
                              'signup.address-procedure.enter-postcode.placeholder',
                              'Enter postcode'
                          )
                }
                label={
                    config.zipCodeAndCountryCheck === true ? (
                        <I18n
                            langKey='signup.address-procedure.postcode.label-zip'
                            defaultText='Zip Code'
                        />
                    ) : (
                        <I18n
                            langKey='signup.address-procedure.postcode.label'
                            defaultText='Postcode'
                        />
                    )
                }
                asideElement={customKeyboard.getAsideElement}
                showSuccessIcon={Boolean(yourDetailsState.isShownFullAddressForm)}
                dataTest='postcode-input'
            />
        </PostcodeWrapper>
    );
});
